export type DomainValue = {
	id: number;
	value: string;
	label: string;
	group: string;
	parentId: number | null;
};

export type MaterialType = {
	id: number;
	label: string;
	value: string;
	category: string;
};

export type DamageGroup = {
	id: number;
	label: string;
	value: string;
};

export const DamageDimension = {
	COUNT: 'COUNT',
	LENGTH: 'LENGTH',
	AREA: 'AREA',
	VOLUME: 'VOLUME',
} as const;
export type DamageDimension = (typeof DamageDimension)[keyof typeof DamageDimension];

export type DamageTypeOption = {
	id: number;
	label: string;
	value: string;
	damageGroupId: number;
	materialCategory: string;
	dimension: DamageDimension;
};
